import { useEffect, useMemo, useState } from "react";

import { useLocation } from "react-router-dom";
import axios from "axios";

import axiosLC, { FIND_ENTITY, FIND_FORM } from "../services";
import { IFE, IFormValues } from "types/types";
import { getAccessToken } from "lib/token";

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const useFormData = () => {
  const query = useQuery();
  const [values, setValues] = useState<IFormValues>(null!);
  const [feId, setFeId] = useState("");
  const [fe, setFe] = useState<IFE>(null!);
  const [userId, setUserId] = useState<string | null>();
  const [ref, setRef] = useState<string>();
  const [branchOffice, setBranchOffice] = useState<string>();
  const [loading, setLoading] = useState(false);

  //https://dev-form-lc.leancore.co/?feId=89949613-2a1d-4b46-9961-4379d05b2fc6&formId=66d1e7f1-895f-405f-adf8-f21962fef990&userId=60e9669e-0690-4936-bded-36a03c1a1b15
  //https://dev-form-lc.leancore.co/?feId=89949613-2a1d-4b46-9961-4379d05b2fc6&formId=66d1e7f1-895f-405f-adf8-f21962fef990&userId=ebbf75ea-28d5-46e2-93f3-280d8977bad3

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const _feId = query.get("feId");
        const _formId = query.get("formId");
        const _userId = query.get("userId");
        const _ref = query.get("ref");
        const _branchOffice = query.get("branchOffice");

        _userId !== null && setUserId(_userId);
        if (_ref !== null && _ref.length > 0) {
          setRef(_ref);
        }
        if (_branchOffice !== null && _branchOffice.length > 0) {
          setBranchOffice(_branchOffice);
        }
        _feId === null && localStorage.clear();
        if (_feId && _formId) {
          setFeId(_feId);
          // ACCESS TOKEN
          //if (!axiosLC.defaults.headers.common["Authorization"]) {
          const token = await getAccessToken();
          axiosLC.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          //}
          // FIND FINANCIAL ENTITY
          const resultFe = await axiosLC.get(`${FIND_ENTITY}?uid=${_feId}`);
          const feData = resultFe.data;
          // console.log("[feData]", feData);
          setFe(feData);
          localStorage.setItem("primaryColor", feData.env.general.primaryColor);
          localStorage.setItem("textColor", feData.env.general.textButtonColor);
          localStorage.setItem("logo", feData.env.general.logo);
          // FIND FORM
          const resultForm = await axiosLC.post(FIND_FORM, {
            feId: _feId,
            formId: _formId,
          });
          const formData = resultForm.data;
          // console.log("[formData]", formData);
          setValues(formData);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log("[error]", error);
        if (axios.isAxiosError(error)) {
          console.log(error?.response?.data);
        }
      }
    })();
  }, [query]);

  return {
    values,
    feId,
    fe,
    userId,
    ref,
    branchOffice,
    loading,
    setLoading,
  };
};
